/**
 * @generated SignedSource<<a04fff98de96a1e0c941b6f91ce8b508>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteChatMessageInput = {
  chatMessageId: string;
  clientMutationId?: string | null | undefined;
};
export type ChatThreadItem_DeleteChatMessageMutation$variables = {
  input: DeleteChatMessageInput;
};
export type ChatThreadItem_DeleteChatMessageMutation$data = {
  readonly deleteChatMessage: {
    readonly chatMessage: {
      readonly deletedAt: string | null | undefined;
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type ChatThreadItem_DeleteChatMessageMutation = {
  response: ChatThreadItem_DeleteChatMessageMutation$data;
  variables: ChatThreadItem_DeleteChatMessageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteChatMessagePayload",
    "kind": "LinkedField",
    "name": "deleteChatMessage",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ChatMessage",
        "kind": "LinkedField",
        "name": "chatMessage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "deletedAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ChatThreadItem_DeleteChatMessageMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ChatThreadItem_DeleteChatMessageMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d1a924d064dc0459b0b850eb81f125c7",
    "id": null,
    "metadata": {},
    "name": "ChatThreadItem_DeleteChatMessageMutation",
    "operationKind": "mutation",
    "text": "mutation ChatThreadItem_DeleteChatMessageMutation(\n  $input: DeleteChatMessageInput!\n) {\n  deleteChatMessage(input: $input) {\n    chatMessage {\n      id\n      deletedAt\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c51bdc419fb2f945644b3025712e1a04";

export default node;
